import Image from "next/image";
import LinkWrapper from "../../../components/Nestable/LinkWrapper/LinkWrapper";
import s from "../Details.module.scss";

type Props = {
  icon: string;
  title: string;
  subtitle?: string;
  eventDate?: string;
};

const parseSubtitle = (subtitle: string) => {
  const urlRegex = /(https?:\/\/[^\s]+)/;
  const match = subtitle.match(urlRegex);

  if (!match) {
    return subtitle;
  }

  const url = match[1];
  const parts = subtitle.split(url);

  return (
    <>
      {parts[0]}
      <LinkWrapper text={url} href={url} variant="light" />
      {parts[1]}
    </>
  );
};

const Detail = ({ icon, title, subtitle }: Props) => {
  return (
    <div className={s.detail}>
      {icon && (
        <Image src={`/svg/icons/${icon}.svg`} width={24} height={24} alt="" />
      )}
      <div className={s.wrapper}>
        <p className={s.title}>{title}</p>
        {subtitle && <p className={s.subtitle}>{parseSubtitle(subtitle)}</p>}
      </div>
    </div>
  );
};

export default Detail;
